import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '../../../assets/img/icons/eye.svg'
import _imports_1 from '../../../assets/img/icons/edit.svg'
import _imports_2 from '../../../assets/img/icons/close.svg'


const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = { class: "py-4 text-center text-muted" }
const _hoisted_4 = {
  key: 4,
  class: "badge bg-light text-dark border"
}
const _hoisted_5 = {
  key: 7,
  class: "d-flex justify-content-center gap-2 table-actions"
}
const _hoisted_6 = ["title", "onClick"]
const _hoisted_7 = ["alt"]
const _hoisted_8 = ["alt"]
const _hoisted_9 = ["title", "onClick"]
const _hoisted_10 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_table, {
        columns: _ctx.columns,
        "data-source": _ctx.salesReturns,
        "row-key": 'id',
        loading: _ctx.loading,
        pagination: _ctx.paginationConfig,
        scroll: { x: 1300 },
        class: "text-nowrap align-middle sales-return-table"
      }, {
        emptyText: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("sales_return_page.no_sales_returns_found")), 1)
        ]),
        bodyCell: _withCtx(({ column, record }) => [
          (column && column.key === 'date')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.formatDate(record.created_at)), 1)
              ], 64))
            : (column && column.key === 'sale_reference')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(record.reference_no || record.sale?.reference_no || _ctx.t("sales_return_page.not_available_short")), 1)
                ], 64))
              : (column && column.key === 'customer')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(record.customer_name || record.customer?.name || _ctx.t("sales_return_page.not_available_short")), 1)
                  ], 64))
                : (column && column.key === 'warehouse')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createTextVNode(_toDisplayString(record.warehouse_name || record.warehouse?.name || _ctx.t("sales_return_page.not_available_short")), 1)
                    ], 64))
                  : (column && column.key === 'total_items')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.t("sales_return_page.items_count", { count: record.total_items || record.items?.length || 0 })), 1))
                    : (column && column.key === 'grand_total')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                          _createTextVNode(" $" + _toDisplayString(Number(record.grand_total || 0).toFixed(2)), 1)
                        ], 64))
                      : (column && column.key === 'status')
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 6,
                            class: _normalizeClass(["status-badge", `status-${String(record.status || 'completed').toLowerCase()}`])
                          }, _toDisplayString(_ctx.formatStatus(record.status)), 3))
                        : (column && column.key === 'actions')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createElementVNode("button", {
                                class: "btn p-0 border-0 action-icon-btn",
                                title: _ctx.t('sales_return_page.view'),
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#salesReturnDetailsModal",
                                onClick: ($event: any) => (_ctx.$emit('view-sales-return', record))
                              }, [
                                _createElementVNode("img", {
                                  src: _imports_0,
                                  alt: _ctx.t('sales_return_page.view'),
                                  style: {"width":"14px"}
                                }, null, 8, _hoisted_7)
                              ], 8, _hoisted_6),
                              _createVNode(_component_router_link, {
                                to: `/edit-sales-return/${record.id}`,
                                title: _ctx.t('sales_return_page.edit'),
                                class: "btn p-0 border-0 action-icon-btn"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("img", {
                                    src: _imports_1,
                                    alt: _ctx.t('sales_return_page.edit'),
                                    style: {"width":"14px"}
                                  }, null, 8, _hoisted_8)
                                ]),
                                _: 1
                              }, 8, ["to", "title"]),
                              _createElementVNode("button", {
                                class: "btn p-0 border-0 action-icon-btn",
                                title: _ctx.t('sales_return_page.delete'),
                                onClick: ($event: any) => (_ctx.$emit('delete-sales-return', record))
                              }, [
                                _createElementVNode("img", {
                                  src: _imports_2,
                                  alt: _ctx.t('sales_return_page.delete'),
                                  style: {"width":"14px"}
                                }, null, 8, _hoisted_10)
                              ], 8, _hoisted_9)
                            ]))
                          : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["columns", "data-source", "loading", "pagination"])
    ])
  ]))
}